import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import { rootRouteRef, createGroupRouteRef, getGroupRouteRef } from './routes';

const keycloakGroupsPage = PageBlueprint.make({
  params: {
    // This is the path that was previously defined in the app code.
    // It's labelled as the default one because it can be changed via configuration.
    path: '/keycloak-groups',
    // You can reuse the existing routeRef by wrapping it with convertLegacyRouteRef.
    routeRef: convertLegacyRouteRef(rootRouteRef),
    // these inputs usually match the props required by the component.
    loader: () =>
      import('./pages/GroupListPage').then(m =>
        // The compatWrapper utility allows you to keep using @backstage/core-plugin-api in the
        // implementation of the component and switch to @backstage/frontend-plugin-api later.
        compatWrapper(<m.GroupListPage />),
      ),
  },
});

const keycloakGroupsCreatePage = PageBlueprint.make({
  name: 'create',
  params: {
    path: '/keycloak-groups/create',
    routeRef: convertLegacyRouteRef(createGroupRouteRef),
    loader: () =>
      import('./pages/GroupCreationPage').then(m =>
        compatWrapper(<m.GroupCreationPage />),
      ),
  },
});

const keycloakGroupsDetailPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: '/keycloak-groups/:groupId',
    loader: () =>
      import('./pages/GroupDetailPage').then(m =>
        compatWrapper(<m.GroupDetailPage />),
      ),
  },
});

/**
 * The Keycloak Groups plugin instance for the new frontend system.
 * @alpha
 */
const plugin: FrontendPlugin = createFrontendPlugin({
  // The plugin ID is now provided as `pluginId` instead of `id`
  pluginId: 'keycloak-groups',
  // bind all the extensions to the plugin
  extensions: [
    keycloakGroupsPage,
    keycloakGroupsCreatePage,
    keycloakGroupsDetailPage,
  ],
  // convert old route refs to the new system
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
    create: createGroupRouteRef,
    get: getGroupRouteRef,
  }),
});

export default plugin;
